import UploadList from "../features/bomScheduler/UploadList";
import FileUpload from "../features/bomScheduler/FileUpload";
import HomeTour from "../features/help/HomeTour";

export default function Home() {
  return (
    <>
      <FileUpload />
      <UploadList />
      <HomeTour />
    </>
  );
}
